export default __webpack_public_path__ + "static/media/upload-icon.a6226356.svg";